import { render, staticRenderFns } from "./CargoTransform.vue?vue&type=template&id=fb90863a&scoped=true&"
import script from "./CargoTransform.vue?vue&type=script&lang=js&"
export * from "./CargoTransform.vue?vue&type=script&lang=js&"
import style1 from "./CargoTransform.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CargoTransform.vue?vue&type=style&index=2&id=fb90863a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb90863a",
  null
  
)

export default component.exports